module.exports = __webpack_public_path__ + "img/logo_red_1.6966ba43.png";